import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ChangeEvent } from "react";

import { t } from "@/i18n-js/instance";
import {
  anchorClassNames,
  legacyClassNames,
} from "@/react/helpers/cssAnchorHelpers";

export type Variant = "default" | "large";

const VARIANTS = {
  DEFAULT: "default",
  LARGE: "large",
} as const;

export interface ToggleSwitchProps {
  className?: string;
  disabled?: boolean;
  field: string;
  label?: string;
  labelClassName?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: boolean;
  variant?: Variant;
  wrapperClassName?: string;
}

export const ToggleSwitch = ({
  field,
  value = false,
  disabled = false,
  onChange,
  variant = "default",
  className,
  labelClassName,
  wrapperClassName,
  label = t("toggle_switch"),
}: ToggleSwitchProps) => (
  <div
    className={classNames(
      anchorClassNames("toggle-switch"),
      "relative",
      wrapperClassName,
      variant === VARIANTS.DEFAULT && legacyClassNames("toggle-switch--small"),
      variant === VARIANTS.LARGE && legacyClassNames("toggle-switch--large"),
    )}
    id={`field-${field}`}
  >
    <input
      type="checkbox"
      name={field}
      id={`checkbox-${field}`}
      checked={value}
      onChange={onChange}
      disabled={disabled}
      className={classNames("peer", className)}
    />
    <label
      htmlFor={`checkbox-${field}`}
      className={classNames(
        "bg-toggle-unchecked before:bg-toggle-circle-unchecked peer-checked:bg-toggle-checked before:peer-checked:bg-toggle-circle-checked relative",
        labelClassName,
      )}
    >
      <span className="sr-only">{label}</span>
    </label>
  </div>
);
